import { LmIconFilledInternetCodeCompass, LmIconOutlineInternetCodeCompass } from '@mes-ui/lemma/icons';

import { WidgetIconProps } from '../types';

const IconSportHikesCommon = ({ iconType, ...rest }: WidgetIconProps) =>
  iconType === 'outlined' ? (
    <LmIconOutlineInternetCodeCompass {...rest} />
  ) : (
    <LmIconFilledInternetCodeCompass {...rest} />
  );

export default IconSportHikesCommon;
